import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  MenuItem,
  ListItemText,
  Typography,
  CircularProgress
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import {
  loadAssignableTickets,
  assignTicketToSector
} from 'state/modules/planimetry'
import { FilterComponent } from '~/views/shared'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'
import { useStyles } from './AssignTicketDialog.style'
import { TICKET_USAGE_LABELS } from 'config/constants'

export const AssignTicketDialog = ({
  open,
  onClose,
  eventId,
  layoutId,
  sectorId,
  sectorName,
  handleClose,
  assignedTicket
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { pendingTickets, pendingAssignTicket, tickets } = useSelector(
    (state) => state.planimetry
  )
  const [searchValue, setSearchValue] = useState('')
  const [filteredTickets, setFilteredTickets] = useState(tickets)
  const [selected, setSelected] = useState(null)

  useEffect(() => {
    if (open) {
      async function fetchData() {
        await dispatch(loadAssignableTickets(layoutId, sectorId, eventId))
      }
      fetchData().then()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  useEffect(() => {
    if (tickets) {
      setFilteredTickets(
        tickets.filter(
          (t) =>
            t.TicketName.toLowerCase().includes(searchValue.toLowerCase()) ||
            t.TicketId.toString().includes(searchValue.toLowerCase())
        )
      )
    }
  }, [searchValue, tickets])

  const handleAssignTicket = async () => {
    if (!selected) return
    try {
      await dispatch(
        assignTicketToSector(layoutId, sectorId, selected.TicketId)
      )
      showSnackbarSuccess('Planimetría asignada con éxito')
      handleCloseDialog()
      handleClose()
    } catch (error) {
      showSnackbarError(error)
      handleCloseDialog()
    }
  }

  const handleCloseDialog = () => {
    setSearchValue('')
    setSelected(null)
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleCloseDialog} maxWidth='sm' fullWidth>
      <DialogTitle style={{ marginRight: 10 }}>
        {assignedTicket ? (
          <>
            Asignar ticket al sector "{sectorName}" - Ticket Asignado:{' '}
            <Typography component='span' style={{ fontWeight: 'bold' }}>
              "{assignedTicket}"
            </Typography>
          </>
        ) : (
          `Asignar ticket al sector "${sectorName}"`
        )}
        <IconButton
          aria-label='close'
          onClick={handleCloseDialog}
          className={classes.closeButton}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <FilterComponent
          performSearch={(val) => setSearchValue(val)}
          searchValue={searchValue}
          placeholder='Buscar ticket por Nombre o Id...'
        />
        <div style={{ overflow: 'auto' }}>
          {pendingTickets ? (
            <div className={classes.containerProgress}>
              <CircularProgress
                size={24}
                className={classes.circularProgress}
              />
              <Typography>Cargando...</Typography>
            </div>
          ) : filteredTickets?.length > 0 ? (
            filteredTickets.map((ticket) => (
              <MenuItem
                key={ticket.TicketId}
                dense
                selected={selected?.TicketId === ticket.TicketId}
                onClick={() => setSelected(ticket)}
                className={
                  selected?.TicketId === ticket.TicketId
                    ? classes.itemContainerSelected
                    : classes.itemContainer
                }>
                <ListItemText
                  primary={`(${ticket.TicketId}) ${ticket.TicketName}`}
                  secondary={`Tipo de ticket: ${TICKET_USAGE_LABELS[ticket.TicketUsage]}`}
                  className={classes.textSpacing}
                />
              </MenuItem>
            ))
          ) : (
            <Typography
              variant='body2'
              color='textSecondary'
              className={classes.emptyList}>
              No se encontraron tickets
            </Typography>
          )}
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseDialog} color='primary'>
          Cancelar
        </Button>
        <Button
          onClick={handleAssignTicket}
          color='primary'
          variant='contained'
          disabled={!selected}
          className={classes.saveButton}>
          {pendingAssignTicket ? (
            <CircularProgress size={24} color='secondary' />
          ) : (
            'Asignar Ticket'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AssignTicketDialog
